// extracted by mini-css-extract-plugin
module.exports = {"illustrations":"illustrations_illustrations__wD0L9","illustrationsContent":"illustrations_illustrationsContent__N4cTm","illustration":"illustrations_illustration__1BjrB"};